<template>
  <form class="userList">
    <div class="userList__checkbox form-check" v-for="option in currentCheckedList" :key="option.id">
      <label class="userList__label">
        <input class="userList__input" type="checkbox" v-model="listItems" :value="option.hash_id" :checked="option.checked" @change="onChange">
        {{ option.name }}
      </label>
    </div>
  </form>
</template>

<script>
import Checkbox from '@/components/Form/Checkbox/checkbox'

import {map, contains} from 'ramda'

export default {
  name: 'List',
  components: {
    Checkbox
  },
  props: {
    data: Array,
    currentIds: {
      type: [Number, Array],
      default: () => []
    }
  },
  created () {
    if (this.currentIds) {
      this.listItems = this.currentIds
    }
  },
  data: () => ({
    listItems: []
  }),
  computed: {
    currentCheckedList () {
      const checked = item => {
        return {
          ...item,
          checked: contains(item.id, this.currentIds)
        }
      }
      return map(checked, this.data)
    }
  },
  methods: {
    onChange () {
      this.$emit('input', this.listItems)
    }
  }
}
</script>

<style lang="scss">
    @import "list";
</style>



// WEBPACK FOOTER //
// src/components/List/list.vue